import type {ReactElement} from 'react';
import type {SocialAccount} from '@Components/social-media/account.vo';

export enum PreviewAccountHeaderLayout {
  STACKED = 'STACKED',
  INLINE = 'INLINE',
}

export interface PreviewAccountHeaderProps {
  account: SocialAccount;
  className?: string;
  identityClassName?: string;
  layout?: PreviewAccountHeaderLayout;
  metaRow: ReactElement | null;
  trailingAction: ReactElement | null;
}
